exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-warning {\r\n    color: #333;\r\n}\r\n.bg-primary-dark{\r\n    background-color: #004a99 !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/ESS-BA20GA30IGW/fspbs4866-detail/fspbs4866-detail.component.css
// module id = ../../../../../src/app/Component/ESS-BA20GA30IGW/fspbs4866-detail/fspbs4866-detail.component.css
// module chunks = main